(function() {
  'use strict';

  // Configuration
  const COLOR_VARIANT_NAMES = ['Color', 'Farbe'];
  const SIZE_VARIANT_NAMES = ['Größe', 'Size'];

  // Selector for all checkout buttons that should be blocked
  const CHECKOUT_BUTTON_SELECTOR = '#checkout, [id="checkout"], #corner-cowi-cart-summary-card-cta-button';

  // Class used to mark hidden buttons and inserted alerts
  const HIDDEN_CLASS = 'cart-block-hidden';
  const ALERT_CLASS = 'cart-blocked-alert';

  /**
   * Get variant option by name (case-insensitive)
   */
  function getVariantOption(item, possibleNames) {
    if (!item.options_with_values) return null;
    
    for (let option of item.options_with_values) {
      if (possibleNames.some(name => name.toLowerCase() === option.name.toLowerCase())) {
        return option.value;
      }
    }
    return null;
  }

  /**
   * Check if cart violates the rules
   */
  function isCartBlocked(cartData) {
    // Group items by product ID
    const productGroups = {};
    
    cartData.items.forEach(item => {
      if (!productGroups[item.product_id]) {
        productGroups[item.product_id] = [];
      }
      productGroups[item.product_id].push(item);
    });

    // Check each product group for violations
    for (let productId in productGroups) {
      const items = productGroups[productId];
      
      // Group by color
      const colorGroups = {};
      let hasNoColorItems = false;
      
      items.forEach(item => {
        const color = getVariantOption(item, COLOR_VARIANT_NAMES);
        const size = getVariantOption(item, SIZE_VARIANT_NAMES);
        
        if (!color) {
          hasNoColorItems = true;
          if (!colorGroups['NO_COLOR']) {
            colorGroups['NO_COLOR'] = [];
          }
          colorGroups['NO_COLOR'].push({ size, item });
        } else {
          if (!colorGroups[color]) {
            colorGroups[color] = [];
          }
          colorGroups[color].push({ size, item });
        }
      });

      // Rule 4: Block if no color is specified and multiple sizes exist
      if (hasNoColorItems && colorGroups['NO_COLOR']) {
        const sizes = colorGroups['NO_COLOR'].map(entry => entry.size).filter(s => s);
        const uniqueSizes = [...new Set(sizes)];
        if (uniqueSizes.length > 1) {
          console.log('Cart blocked: Multiple sizes for product without color');
          return true;
        }
      }

      // Check each color group
      for (let color in colorGroups) {
        if (color === 'NO_COLOR') continue;
        
        const colorItems = colorGroups[color];
        const sizes = colorItems.map(entry => entry.size).filter(s => s);
        const uniqueSizes = [...new Set(sizes)];
        
        // Rule 1: Block if same color has multiple different sizes
        if (uniqueSizes.length > 1) {
          console.log(`Cart blocked: Multiple sizes (${uniqueSizes.join(', ')}) for same color (${color})`);
          return true;
        }
      }
    }

    return false;
  }

  /**
   * Hide checkout buttons and show alert messages
   */
  function blockCheckout() {
    const checkoutButtons = document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR);
    
    checkoutButtons.forEach(button => {
      // Skip if already hidden
      if (button.classList.contains(HIDDEN_CLASS)) return;
      
      // Hide the original button but keep it in the DOM
      button.classList.add(HIDDEN_CLASS);
      button.style.setProperty('display', 'none', 'important');
      
      // Insert alert message after the hidden button
      const alert = document.createElement('div');
      alert.className = ALERT_CLASS;
      alert.style.cssText = `
        padding: 15px;
        background-color: #f44336;
        color: white;
        border-radius: 4px;
        text-align: center;
        font-weight: bold;
        margin: 10px 0;
      `;
      alert.textContent = 'Aktuell nehmen wir leider keine Bestellungen mit mehreren Größen des selben Produkts oder der selben Farbe entgegen. Bitte passe deinen Warenkorb an um mit deiner Bestellung fortzufahren.';
      
      button.parentNode.insertBefore(alert, button.nextSibling);
    });
    
    // Hide dynamic checkout buttons
    const dynamicCheckoutButtons = document.querySelectorAll('.cart__dynamic-checkout-buttons');
    dynamicCheckoutButtons.forEach(element => {
      element.classList.add(HIDDEN_CLASS);
      element.style.setProperty('display', 'none', 'important');
    });
  }

  /**
   * Restore checkout buttons and remove alert messages
   */
  function restoreCheckout() {
    // Remove all alert messages
    const alerts = document.querySelectorAll('.' + ALERT_CLASS);
    alerts.forEach(alert => alert.remove());
    
    // Show all hidden checkout buttons
    const hiddenButtons = document.querySelectorAll('.' + HIDDEN_CLASS);
    hiddenButtons.forEach(button => {
      button.classList.remove(HIDDEN_CLASS);
      button.style.display = '';
    });
  }

  /**
   * Main function to check cart and apply rules
   */
  async function checkCart() {
    try {
      // Fetch cart data from Shopify Cart API
      const response = await fetch('/cart.js');
      const cartData = await response.json();
      
      console.log('Cart data:', cartData);
      
      // Check if cart should be blocked
      if (isCartBlocked(cartData)) {
        blockCheckout();
      } else {
        restoreCheckout();
      }
    } catch (error) {
      console.error('Error checking cart:', error);
    }
  }

  // Run check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkCart);
  } else {
    checkCart();
  }

  // Also run check when cart is updated (if using Shopify's cart events)
  document.addEventListener('cart:updated', checkCart);
  
  // Listen for any AJAX cart updates
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const promise = originalFetch.apply(this, args);
    
    // Re-check cart after any cart API calls
    if (args[0] && (args[0].includes('/cart/') || args[0].includes('/cart.js'))) {
      promise.then(() => {
        setTimeout(checkCart, 100);
      });
    }
    
    return promise;
  };

  // Listen for cart changes using MutationObserver (for themes that update cart without AJAX)
  const observer = new MutationObserver(() => {
    checkCart();
  });

  // Observe cart container for changes
  const cartObserverInit = () => {
    const cartContainers = document.querySelectorAll('[data-cart], .cart, #cart');
    cartContainers.forEach(container => {
      observer.observe(container, {
        childList: true,
        subtree: true
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cartObserverInit);
  } else {
    cartObserverInit();
  }
})();